var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinPageNavIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400819 0.00162569H2.44586C2.55434 0.00162569 2.65837 0.0447184 2.73507          0.121424C2.81178 0.19813 2.85487 0.302165 2.85487 0.410643V3.73595L8.35603 0.0547979C8.4182          0.0188992 8.48874 0 8.56053 0C8.63233 0 8.70286 0.0188992 8.76504 0.0547979C8.83127          0.0881475 8.88718 0.138876 8.92681 0.201555C8.96643 0.264235 8.98827 0.336508 8.98999          0.410643V8.59098C8.98979 8.66498 8.96953 8.73753 8.93135 8.80091C8.89318 8.8643 8.83853          8.91614 8.77322 8.95092C8.70926 8.98376 8.63777 8.99916 8.56597 8.99557C8.49416 8.99198          8.42457 8.96952 8.36421 8.93047L2.86305 5.24931V8.59098C2.86305 8.69946 2.81996 8.8035          2.74325 8.8802C2.66655 8.95691 2.56252 9 2.45404 9H0.408998C0.300523 9 0.19649 8.95691          0.119786 8.8802C0.0430822 8.8035 -9.53674e-06 8.69946 -9.53674e-06 8.59098V0.410643C-3.05176e-05          0.303567 0.0419369 0.200753 0.11688 0.124278C0.191824 0.0478035 0.293767 0.00376719 0.400819          0.00162569Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinPageNavIconLeft);
export default __webpack_public_path__ + "static/media/sinPageNavIcon-left.59434e8f8b0bff182f619d005da6c256.svg";
export { ForwardRef as ReactComponent };